export const replaceNbsp = (text: string) => text.replace(/&nbsp;/g, ' ');
